import React from "react";
import { SelectTarget, UsersList } from "./views";

export const UserInformation: React.FC = () => {
  return (
    <React.Fragment>
      <SelectTarget />
      <UsersList />
    </React.Fragment>
  );
};
